import React from "react";
import { T } from "../../../app/tokens.js";
import { weekLabel } from "./weeklyModel.js";
import { WeeklyRichText } from "./WeeklyRichEditor.jsx";
import { weeklyText } from "../../../lib/weeklyRichText.js";
import { btn, muted } from "./weeklyUi.js";

export function LastPosted({ source, testId }) {
  if (!source) return null;
  return <details data-testid={testId} style={{ ...muted, marginTop: 8 }}>
    <summary style={{ cursor: "pointer" }}>Last posted · {weekLabel(source.weekDate)}{source.authorName ? ` · ${source.authorName}` : ""}</summary>
    <div style={{ marginTop: 6, padding: "8px 10px", borderLeft: `2px solid ${T.border}` }}><WeeklyRichText value={source.text} /></div>
  </details>;
}

export function CarryForward({ source, value, savedValue, onCarry, carried, disabled = false, testId }) {
  if (!source) return null;
  return <div style={{ margin: "6px 0" }}>
    {carried ? <div role="status" data-testid={`${testId}-notice`} style={muted}>Carried forward from {weekLabel(source.weekDate)} · edit before posting</div>
      : !weeklyText(value).trim() && !weeklyText(savedValue).trim() && <button type="button" data-testid={testId} disabled={disabled} style={btn} onClick={() => onCarry(source)}>Start from last week</button>}
  </div>;
}
